import { Tooltip } from 'bootstrap';

import { EXPORT_IN_PROGRESS_MESSAGE } from '@/shared/constants';
import { routes } from '@/shared/routes';

import { execute } from '@/front/actions/utils';
import { DELETE, POST } from '@/front/fetch';
import { GdprErasureModalAccount, isActivePayingCustomer, openGdprErasureModal } from '@/front/gdprErasureModal';
import { alertModal } from '@/front/modal';

export const exportAccount = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  button.dataset.disabled = 'true';

  const tooltipOptions: Partial<Tooltip.Options> = {
    title: EXPORT_IN_PROGRESS_MESSAGE,
    placement: 'bottom',
  };

  const tooltip = new Tooltip(button, { ...tooltipOptions, trigger: 'manual' });
  tooltip.show();

  // Show tooltip immediately for 5 seconds then on hover
  setTimeout(() => {
    tooltip.hide();
    tooltip.dispose();
    new Tooltip(button, tooltipOptions);
  }, 5000);

  await execute(POST, routes.account.export());
};

export const disconnectXama = async () => {
  await execute(DELETE, routes.account.xama());
};

export const disconnectFreeAgent = async () => {
  await execute(DELETE, routes.account.freeagent());
};

export const completeOnboardingStep = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const step = button.dataset.onboardingStep;
  if (step) {
    await POST(routes.account.onboarding.updateStep(), {
      step,
      status: 'Done',
    });
  }
};

export const deletePortalLogo = async () => {
  await execute(DELETE, routes.account.portalLogo());
};

export const resendSigningAuthorisation = async () => {
  await execute(POST, routes.account.signingAuthorisation());
};

export const deleteSigningAuthorisation = async () => {
  await execute(DELETE, routes.account.signingAuthorisation());
};

export const setupEmailDomain = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const input = button.closest('tr')?.querySelector<HTMLInputElement>('[data-email-domain-input]');
  const domain = input?.value.trim();

  if (!domain) {
    await alertModal('Please enter a domain name.');
    return;
  }

  await execute(POST, routes.account.emailDomain(), { domain });
};

export const verifyEmailDomain = async () => {
  await execute(POST, routes.account.emailDomainVerify());
};

export const removeEmailDomain = async () => {
  await execute(DELETE, routes.account.emailDomain());
};

export const resetAccount = async () => {
  await execute(POST, routes.account.reset());
};

export const requestGdprErasure = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const accountId = button.dataset.value;
  const accountName = button.dataset.accountName;
  const accountStatus = button.dataset.accountStatus;

  if (!accountId || !accountName || !accountStatus) {
    return;
  }

  const account: GdprErasureModalAccount = {
    name: accountName,
    status: accountStatus,
    trialExpiresTime: button.dataset.trialExpiresTime,
    subscriptionExpiresTime: button.dataset.subscriptionExpiresTime,
    subscriptionCancelledTime: button.dataset.subscriptionCancelledTime,
    deletionScheduledTime: button.dataset.deletionScheduledTime,
  };

  const hardDeleteAt = await openGdprErasureModal(account);

  if (!hardDeleteAt) {
    return;
  }

  const res = await POST(routes.admin.accounts.requestGdprErasure({ id: accountId }), {
    hardDeleteAt: hardDeleteAt.toISOString(),
    ...(isActivePayingCustomer(accountStatus) ? { confirmActiveAccountName: accountName } : {}),
  });
  const message = await res.text();

  if (message) {
    alertModal(message);
  }

  window.location.reload();
};
